import { useAuth0 } from '@auth0/auth0-react';

export const isSocialConnected = () => {
  const { user } = useAuth0();

  if (user && user.sub) {
    const provider = user.sub.split('|')[0];
    return provider !== 'auth0';
  }
  return false;
};
